import React, { Context } from 'react';
import { MimicContext } from '../interfaces/MimicContext';

const contextKey = '__DAAP_PORTAL_MIMIC_CONTEXT__';

export function getMimicContext() {
  let context = (React.createContext as never)[
    contextKey
  ] as Context<MimicContext>;
  if (!context) {
    Object.defineProperty(React.createContext, contextKey, {
      value: (context = React.createContext<MimicContext>({
        isMimic: false,
        status: 'idle',
        showMimicModal: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setShowMimicModal: () => {},
      })),
      enumerable: false,
      writable: false,
      configurable: true,
    });
    context.displayName = 'DaapMimicContext';
  }
  return context;
}
